/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_History_TitleInputs */

const en_settings_history_title = /** @type {(inputs: Settings_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription history`)
};

const id_settings_history_title = /** @type {(inputs: Settings_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riwayat langganan`)
};

/**
* | output |
* | --- |
* | "Subscription history" |
*
* @param {Settings_History_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_history_title = /** @type {((inputs?: Settings_History_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_History_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_history_title(inputs)
	return en_settings_history_title(inputs)
});